import { GHID, STRATEGICAL, GGML, GGND, GGNO, GGSD, GGSO } from '../helpers/authorization';

const routes = {
    login: {
        path: '/Login',
        children: {
            loginForm: {
                path: '/',
                name: 'Login'
            },
            forgotPassword: {
                path: '/Forgot',
                name: 'ForgotPassword'
            },
            resetPassword: {
                path: '/ResetPassword',
                name: 'ResetPassword'
            }
        }
    },
    weather: {
        path: '/',
        name: 'Weather',
    },
    home: {
        path: '/Home',
        name: 'Home',
        authorize: [GHID, STRATEGICAL, GGML, GGND, GGNO, GGSD, GGSO],
    },
    reservoirs: {
        path: '/Reservoirs',
        name: 'Reservoirs',
        title: 'Reservatórios',
        authorize: [GHID, STRATEGICAL, GGML],
    },
    monitoring: {
        path: '/Monitoring',
        name: 'Monitoring',
        title: 'Monitoramento',
        authorize: [GHID, STRATEGICAL, GGML, GGND, GGNO, GGSD, GGSO],
    },
    conservation: {
        path: '/Conservation',
        name: 'Conservation',
        title: 'Conservação',
        authorize: [GHID, STRATEGICAL, GGML, GGND, GGNO, GGSD, GGSO],
    },
    indicators: {
        path: '/Indicators',
        name: 'Indicators',
        title: 'Indicadores',
        authorize: [GHID, STRATEGICAL, GGML, GGND, GGNO, GGSD, GGSO],
    },
    effluents: {
        path: '/Effluents',
        name: 'Effluents',
        title: 'Efluentes',
        authorize: [GHID, STRATEGICAL, GGML, GGND, GGNO, GGSD, GGSO],
    },
    undergroundWaters: {
        path: '/Underground-Waters',
        name: 'UndergroundWaters',
        title: 'Águas Subterrâneas',
        authorize: [GHID, STRATEGICAL, GGML, GGND, GGNO, GGSD, GGSO],
    },
    guides: {
        path: '/Guides',
        name: 'Guides',
        title: 'Manual do Usuário',
        authorize: [GHID, STRATEGICAL, GGML, GGND, GGNO, GGSD, GGSO],
    },
    rainEstimationHistoricalData: {
        path: '/RainEstimationHistoricalData/:previus/:locationid',
        name: 'RainEstimationHistoricalData',
        title: 'Dados históricos da estimativa de chuva',
        props: true,
        authorize: [GHID, STRATEGICAL, GGML, GGND, GGNO, GGSD, GGSO],
    },
    stationsData: {
        path: '/Stations-Data',
        name: 'StationsData',
        title: 'Dados das estações',
        authorize: [GHID, STRATEGICAL, GGML, GGND, GGNO, GGSD, GGSO],
    },
    reports: {
        path: '/Reports',
        name: 'Reports',
        title: 'Repositório de relatórios',
        authorize: [GHID, STRATEGICAL, GGML, GGND, GGNO, GGSD, GGSO],
    },
    responseError: {
        path: '/error',
        name: 'ResponseError',
    }
};

export default routes;
